import { Component } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { PrescriptionDataContainer, UserData } from "../../model/index";

@Component({
    providers: [Http]
})
export class PrescriptionsService {
    constructor(private _http: Http) {
    }
    private _PrescriptionServiceurl: string = "/api/prescriptions/list";

    public getPrescriptions(userId: string, authentication: string, pid: string, isAdmin: boolean): Observable<PrescriptionDataContainer> {
        var userData: UserData = new UserData(userId, authentication, pid, isAdmin);

        let body: string = JSON.stringify(userData);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });
         let data$: Observable<PrescriptionDataContainer> = this._http.post(this._PrescriptionServiceurl, body, options)
            .map(res => <PrescriptionDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }
    private handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || "";
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg || " API Server Error");
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/prescriptions/service/prescriptions.service.ts